import React, {useEffect, useState} from 'react';
import API_BASE_URL from '../../config';
import Navbar from '../../components/Navbar/Navbar';


export default function AcPendencia() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({key: '', direction: ''});
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/ac/pendentes`);
                if (!response.ok) {
                    throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
                }
                const result = await response.json();

                // Ordenar os dados por 'dataMovimentacao' em ordem crescente (mais antigo para o mais recente)
                result.sort((a, b) => parseDate(a.dataMovimentacao) - parseDate(b.dataMovimentacao));
                setData(result);
            } catch (error) {
                console.error('Erro ao buscar dados:', error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const sortData = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({key, direction});
    };

    const statusMap = {
        1: 'Despacho Notificação',
        2: 'Relatório',
        3: 'Análise Técnica',
        4: 'Solicitado Documentação',
        5: 'Análise Documental',
        6: 'Análise Encerramento',
        7: 'Deferido',
        8: 'Indeferido',
        9: 'Arquivado',
        10: 'Recebimento do pedido'
    };

    const statusTipo = {
        1: 'AC 1',
        2: 'AC 2',
    }

    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day);
    };

    const filteredData = data.filter(item =>
        item.processo.toString().includes(searchTerm)
    );

    const sortedData = [...filteredData].sort((a, b) => {
        if (sortConfig.key === 'dataMovimentacao') {
            const dateA = parseDate(a.dataMovimentacao);
            const dateB = parseDate(b.dataMovimentacao);
            if (dateA < dateB) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (dateA > dateB) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        } else {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }

            return 0;
        }
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(sortedData.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const getSortDirectionIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '↑' : '↓';
        }
        return '';
    };

    const downloadPDF = (pdfFilePath) => {
        const link = document.createElement('a');
        link.href = pdfFilePath;
        link.download = pdfFilePath.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getStatusBorderClass = (status) => {
        switch (statusMap[status]) {
            case 'Recebimento do Pedido':
                return 'borda-cinza';
            case 'Análise Técnica':
                return 'borda-azul-claro';
            case 'Análise Documental':
                return 'borda-azul-escuro';
            case 'Relatório':
                return 'borda-verde-claro';
            case 'Despacho Notificação':
                return 'borda-verde-escuro';
            case 'Análise Encerramento':
                return 'borda-roxo';
            case 'Solicitado Documentação':
                return 'borda-vermelho';
            default:
                return ''; // sem borda
        }
    };

    return (
        <div className="home">
            <Navbar searchTerm={searchTerm} onSearchChange={setSearchTerm}/>
            <div className="table-container">
                {loading ? (
                    <p>Carregando...</p>
                ) : (
                    <>
                        <table className="data-table">
                            <thead>
                            <tr>
                                <th>Ordem</th>
                                <th>
                                    Tipo
                                </th>
                                <th>
                                    Processo
                                </th>
                                <th>
                                    Data da Movimentação
                                </th>
                                <th>
                                    Status
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((item, index) => (
                                    <tr key={item.id_ac_atendimento}>
                                        <td data-label="Ordem">{indexOfFirstItem + index + 1}</td>
                                        <td data-label="Tipo">{statusTipo[item.tipo]}</td>
                                        <td data-label="Processo">{item.processo}</td>
                                        <td data-label="Data da Movimentação">{item.dataMovimentacao}</td>
                                        <td data-label="Status">
                                            <div className={getStatusBorderClass(item.status)}>
                                                {statusMap[item.status] || 'Status desconhecido'}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7">Nenhum credenciamento encontrado!</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button
                                onClick={prevPage}
                                className="page-button"
                                disabled={currentPage === 1}
                            >
                                Anterior
                            </button>
                            {Array.from({length: totalPages}, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => paginate(i + 1)}
                                    className={`page-button ${currentPage === i + 1 ? 'active' : ''}`}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                onClick={nextPage}
                                className="page-button"
                                disabled={currentPage === totalPages}
                            >
                                Próxima
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}